import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rename',
  templateUrl: './rename.component.html',
  styleUrls: ['./rename.component.scss'],
})
export class RenamePage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
